// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1TijM","content":"styles_content__2kzhx","checkbox":"styles_checkbox__3BlPJ","checkboxLabel":"styles_checkboxLabel__1fDoY"};